export default __webpack_public_path__ + "static/media/2.13aa02f5.jpg";